import axios from "shared/api/axiosConfig";

export async function getStatForAllDocRequested(userType) {
  const url = '/client/stat_for_all_doc_requested';
  const body = new FormData();
  body.append('type', userType);
  try {
    const response = await axios.post(url, body);
    return response.data;
  } catch (error) {
    return {};
  }
}